import {AbilityBuilder} from '@casl/ability';
import {CommonAbility} from '../common-abilities';
import {PolicyIdentity} from './policy-account';
import {hasRole} from './policy-helpers';

export enum SystemRoles {
  SystemAdmin = 'system-admin',
  TenantAdmin = 'tenant-admin',
}

/**
 * Role Management Authorization Policies
 *
 * Tenant isolation is handled by defineGlobalPolicies.
 * The only remaining business constraint here is protecting system roles.
 * System roles (isSystemRole: true) can only be modified/deleted by system admins.
 *
 * CRITICAL: This policy MUST run AFTER defineGlobalPolicies in the policy
 * definitions array so its cannot() rules are not overridden by the broader
 * can('manage', 'all') from global policies.
 */
export function defineRolePolicies(identity: PolicyIdentity, builder: AbilityBuilder<CommonAbility>): void {
  const {cannot} = builder;

  // Only non-system-admins are blocked from modifying/deleting system roles.
  // SystemAdmin already has can('manage', 'all') from defineGlobalPolicies.
  if (!hasRole(identity, SystemRoles.SystemAdmin)) {
    cannot('update', 'Role', {isSystemRole: true}).because('System roles cannot be modified');
    cannot('delete', 'Role', {isSystemRole: true}).because('System roles cannot be deleted');
  }
}
